<template>
  <el-dialog
    title="添加机台"
    :visible.sync="machineAddDialogVisible"
    width="50%"
    @close="machineAddDialogClosed"
    :close-on-click-modal="false"
  >
    <el-form
      :model="machine"
      :rules="machineRelues"
      ref="machineaAddForm"
      label-width="145px"
    >
      <el-form-item label="机台归类:" prop="machineKind">
        <el-select v-model="machine.machineKind" clearable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机台编号:" prop="number">
        <el-input v-model="machine.number"></el-input>
      </el-form-item>
      <el-form-item label="所在车间:" prop="workshop">
        <el-input v-model="machine.workshop"></el-input>
      </el-form-item>
      <el-form-item label="轴长(米):" prop="warpKnittingMachineAxialLength">
        <el-input v-model="machine.warpKnittingMachineAxialLength"></el-input>
      </el-form-item>
      <el-form-item label="面梳(个):" prop="warpKnittingMachineMaxComb">
        <el-input v-model="machine.warpKnittingMachineMaxComb"></el-input>
      </el-form-item>
      <el-form-item label="机台类型:" prop="machineType">
        <el-input v-model="machine.machineType"></el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input v-model="machine.remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="onSubmit()">创建</el-button>
      <el-button @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as api from "@/api/factory/machine/list/add";
export default {
  data() {
    var lengthruler = (rules, value, cb) => {
      const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/;
      if (ruler.test(value)) {
        return cb();
      }

      cb(new Error("请输入大于0的正整数"));
    };
    return {
      options: [
        {
          value: 0,
          label: "经编机",
        },
        {
          value: 1,
          label: "整经机",
        },
      ],
      value: "",
      machineAddDialogVisible: false,
      machine: {
        machineKind: 0,
        number: "",
        workshop: "",
        warpKnittingMachineAxialLength: "",
        warpKnittingMachineMaxComb: "",
        machineType: "",
        remark:"",
      },
      machineRelues: {
        machineKind: [
          {
            required: true,
            message: "请选择机台归类",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "请输入机台编号",
            trigger: "blur",
          },
        ],
        workshop: [
          {
            required: true,
            message: "请输入所属车间",
            trigger: "blur",
          },
        ],
        // warpKnittingMachineAxialLength: [{
        //         required: true,
        //         message: '请输入轴长',
        //         trigger: 'blur'
        //     },
        //     {
        //         validator: lengthruler,
        //         trigger: 'blur'
        //     }
        // ],
        // warpKnittingMachineMaxComb: [{
        //         required: true,
        //         message: '请输入面梳',
        //         trigger: 'blur'
        //     },
        //     {
        //         validator: lengthruler,
        //         trigger: 'blur'
        //     }
        // ],
        // machineType: [{
        //     required: true,
        //     message: '请输入机台类型',
        //     trigger: 'blur'
        // }],
      },
    };
  },
  methods: {
    // 外部调用，显示添加机台弹框
    show() {
      this.machineAddDialogVisible = true;
    },
    // 监听回车按钮
    keyCodeListen() {
      // const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode
      const code = event.keyCode;
      if (code === 13) this.onSubmit();
    },
    // 点击创建按钮
    onSubmit() {
      this.$refs.machineaAddForm.validate((valid) => {
        if (!valid) return;
        const data = this.machine;
        api.onSubmit(data).then((res) => {
          console.log(res);
          this.$Message.success("机台创建成功！");
          this.$refs.machineaAddForm.resetFields();
          this.machineAddDialogVisible = false;
          // TODO 隐藏性的问题 如果当前页达到size上限，再去创应该是去请求一下页了
          this.$emit("update");
        });
      });
    },
    // 点击取消按钮触发
    cancel() {
      this.machineAddDialogVisible = false;
    },
    mounted() {
      document.addEventListener("keyup", this.keyCodeListen);
    },
    destroyed() {
      document.removeEventListener("keyup", this.keyCodeListen);
    },
  },
};
</script>

<style lang="scss" scoped></style>
